module.exports = __webpack_public_path__ + "static/img/day_report_win3.7362b42c.png";